type Props = {
  onMenuToggle?: () => void;
}
/**
 * Mobile Nav Bar hamburger button
 */
export const HamburgerButton = ({ onMenuToggle }: Props) => {
  return (
    <div className="l-header__left u-hide-sm-up">
      <div
        tabIndex={-1}
        className="global-utilities__button btnMenuDropDown"
        onClick={onMenuToggle}
      >
        <div
          className="global-utilities__button__icon hamburger-menu-icon"
          aria-hidden="true"
        >
          <i className="icon icon-menu"></i>
        </div>
      </div>
    </div>
  );
};
